// Syllabus (tanmenet) store. Deliberately NOT in the persistedstate `paths` allowlist in
// store/index.js: a restored upload/job state would poll a job that no longer exists.

// A fresh "nothing in flight" upload state. A factory, not a constant: Vuex uses the
// exported state object itself as the live module state, so a constant default would
// always equal the current value and RESET_UPLOAD could never reset anything.
export const defaultUpload = () => ({
  classId: null,
  // 'idle' | 'uploading' | 'reading' | 'lessons_failed' | 'done' | 'non_language' | 'failed'
  // lessons_failed: some chapters stayed unread; the reading card offers the retry.
  status: 'idle',
  jobId: null,
  syllabusId: null,
  job: null,
  error: null,
  fileLabel: '',
  // The File objects of the last pick, kept for "Feldolgozás így is" (re-upload with
  // forceLanguage). Not serialisable, which is one more reason this module is not persisted.
  files: [],
  photoOrigin: false
});

const state = {
  // { [classId]: syllabus | null }  null = loaded, the class has no syllabus
  byClass: {},
  // { [classId]: true } once getClassSyllabus answered, so every entry point loads at most once
  loadedClasses: {},
  // The one upload in flight (the uploader is per class, but a teacher uploads one at a time).
  upload: defaultUpload(),
  // { [classId]: true } while the teacher stepped back from the scope card to the check card
  // ("‹ Vissza az ellenőrzéshez"): the server keeps the confirmation, only the screen goes back.
  checkAgain: {},
  // The last parse/upload failure to show on the uploader card (S 7.3), { classId, code } or null.
  lastError: null,
  // { [syllabusId]: n } "Újrapróbálás" presses this session; after one the reading card also
  // offers another file.
  lessonRetries: {}
};

export default state;



// WEBPACK FOOTER //
// ./src/store/modules/syllabus/state.js